export enum PoliciesType {
  ForAdmin = 'ForAdmin',
  ForRead = 'ForRead',
  ForUnAuth = 'policyNotValidJustForTest',
}
